import { useQuery } from 'react-query';
import { GroupApi } from '../api/group';

export const useGroups = () => {
  return useQuery({
    queryFn: async () => {
      const groups = await GroupApi.fetchGroups();
      return groups ?? [];
    },
    queryKey: ['groups'],
    refetchOnWindowFocus: false,
  });
};
